import EA from 'helpers/init';

export default EA.Methods.languageChoose = ($this, payload) => {
    var lang = $this.getAttribute('lang');
    var redirects = JSON.parse($this.getAttribute('sites'));
    if(getCookie('cb_accepted') && getCookie('lang_cookie') && getCookie('lang_cookie') != lang){
        if(redirects[getCookie('lang_cookie')] != undefined){
            document.body.style.display = 'none';
            window.location.replace(redirects[getCookie('lang_cookie')]);
        }
    }
    if(getCookie('lang_cookie')){
        document.getElementById('lang-wrap').style.display = 'none';
    } else {
        if(getCookie('cb_accepted')){
            document.getElementById('lang-wrap').style.display = 'flex';
        }else{
            document.getElementById('lang-wrap').style.display = 'none';
        }
    }
    window.addEventListener('CookiebotOnLoad', function () {
        window.addEventListener('CookiebotOnAccept', handleCookiebotOnAccept)
        window.addEventListener('CookiebotOnDecline', handleCookiebotOnDecline)
        
        window.CookiebotCallback_OnAccept = this.cookiebotCallbackOnAccept
        window.CookiebotCallback_OnDecline = this.cookiebotCallbackOnDecline
    })
    if(!getCookie('CookieConsent')){
        // disableScroll();
    }


    function handleCookiebotOnAccept() {
        setCookie("cb_accepted", true, 364);
        if (Cookiebot.changed)
        {
            location.reload(true);
        }

    };
    function handleCookiebotOnDecline() {
        removeCookie('cb_accepted');
        removeCookie('lang_cookie');
        if (Cookiebot.changed)
        {
            location.reload(true);
        }
    };
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = name + "=" + value + "; expires=" + expires + "; path=/; SameSite=Lax; Secure";
    };
    function getCookie(name) {
        var nameEQ = name + "=";
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1, cookie.length);
            }
            if (cookie.indexOf(nameEQ) === 0) {
                return cookie.substring(nameEQ.length, cookie.length);
            }
        }
        return null;
    };
    function removeCookie(cookieName) {
        document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
    function disableScroll() {
        document.body.style.overflow = 'hidden';
    }
    
    function enableScroll() {
        document.body.style.overflow = '';
    }
};

